import { ConversationDataResponse } from "@virtualprogaming/js-public-sdk";
import { useQuery, UseQueryOptions } from "react-query";

import { useChatApi } from "./useChatApi";

export function useChatConversations(
  accessToken: string,
  top: number,
  search: string,
  options?: UseQueryOptions<ConversationDataResponse>
) {
  const api = useChatApi();
  return useQuery({
    queryKey: ["chat-conversations", accessToken, top, search],
    queryFn: async () => {
      const { data } = await api.getConversations(
        accessToken,
        undefined,
        top,
        undefined,
        undefined,
        search
      );
      return data;
    },
    ...options,
    refetchInterval: 6000,
  });
}
